import { createFileRoute } from '@tanstack/react-router';
import { Seo } from '@/components/seo';
import { HeroHeader } from '../components/header';
import FooterSection from '../components/footer';
import { ContactForm } from '@/features/contact/components/ContactForm';

export const Route = createFileRoute('/contact-us')({
  component: ContactUsPage,
});

function ContactUsPage() {
  return (
    <>
      <Seo
        title="Contact Boundr — We're Here to Help"
        description="Have a question about monitoring your property in India? Send the Boundr team a message and we'll get back to you."
        path="/contact-us"
      />
      <HeroHeader />

      <main className="pt-24 md:pt-36 pb-16">
        <div className="mx-auto max-w-2xl px-6">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-semibold md:text-4xl mb-3">Contact Us</h1>
            <p className="text-muted-foreground">
              Have a question or need help? Send us a message and we'll get back to you.
            </p>
          </div>

          <ContactForm />
        </div>
      </main>

      <FooterSection />
    </>
  );
}
